module.exports = __webpack_public_path__ + "static/media/8-1.242ed9ca.mp3";